/**
 * 建站名称预填（揽收站点 2.0）。
 *
 * 规则对齐后端自动建站：`联系人-地址前两段-邮编-序号`，后缀改用**预占站点 ID**。
 * 后端用的是 cooperationWarehouseService.count()，前端拿不到；预占 ID 天然唯一且单调，
 * 更能避免撞 name 唯一索引。生成后运营可在表单里直接改。
 *
 * 两个入口共用，差别只在取数来源：
 * - 「新地址审核 → 创建新站点」：取审核池条目自身的地址与联系人
 * - 「AB 地址映射 → 新建 B 站点」：取**标准化后的 B 地址**与选中维度的联系人。
 *   B 是实际上门点，若沿用 A（下单地址）拼名字，站点名会指向另一个城市/邮编，
 *   运营按名字找站点会找错（如 A 在 Brooklyn 11203、B 在 Whitestone 11357）。
 *
 * @param cwId 预占的草稿站点 ID；为空返回 undefined（草稿还没建出来，不生成半截名字）
 */
export const buildSuggestedSiteName = (input: {
  contactName?: string | null;
  addressLine1?: string | null;
  zipcode?: string | null;
  cwId?: number | null;
}): string | undefined => {
  if (input.cwId == null) return undefined;
  const contactName = input.contactName?.trim();
  const street = (input.addressLine1 ?? '')
    .split(' ')
    .filter(Boolean)
    .slice(0, 2)
    .join(' ');
  return [contactName, street, input.zipcode, input.cwId]
    .filter((v) => v !== undefined && v !== null && v !== '')
    .join('-');
};
